import React from "react";

const WelcomeNewEmployees = ({ employees = [] }) => {
  return (
    <div className="card welcome-card">
      {/* HEADER */}
     <div className="card-header birthday-snow-header">
        <h5 className="card-title mb-0">👋 Welcome New Employees</h5>
      </div>

      {/* 👇 MANUAL SCROLL BODY */}
      <div className="card-body p-2 birthday-scroll-manual">
        {employees.length === 0 ? (
          <p className="text-muted text-center mb-0">
            No new employees today
          </p>
        ) : (
          employees.map((emp, index) => (
            <div className="welcome-row" key={index}>
              {/* Avatar */}
              <div className="welcome-avatar">
                {emp.employee_name
                  .split(" ")
                  .map(n => n[0])
                  .join("")
                  .slice(0, 2)
                  .toUpperCase()}
              </div>

              {/* Info */}
              <div className="welcome-info">
                <div className="welcome-name">
                  {emp.employee_name}
                </div>

                <div className="welcome-department">
                  {emp.department_name}
                </div>

                {/* <div className="welcome-date">
                  {emp.join_date}
                </div> */}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default WelcomeNewEmployees;
